(function() {
  function initStatsBar(section) {
    var countElements = section.querySelectorAll('[data-count-up]');
    if (!countElements.length) return;

    var hasAnimated = false;
    var duration = 2000;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    /**
     * Splits a stat value into segments of numbers and non-numbers.
     * "24/7"   → [{num: 24}, {text: "/"}, {num: 7}]
     * "$1,000" → [{text: "$"}, {num: 1000, formatted: "1,000"}, {text: "+"}] etc.
     */
    function parseSegments(str) {
      var segments = [];
      var regex = /([0-9][0-9,]*\.?[0-9]*)|([^0-9]+)/g;
      var match;
      while ((match = regex.exec(str)) !== null) {
        if (match[1]) {
          var raw = match[1];
          var num = parseFloat(raw.replace(/,/g, ''));
          segments.push({ type: 'number', value: num, original: raw });
        } else {
          segments.push({ type: 'text', value: match[2] });
        }
      }
      return segments;
    }

    function formatNumber(num, original) {
      var hasCommas = original.indexOf(',') !== -1;
      var decimalMatch = original.match(/\.(\d+)/);
      var decimals = decimalMatch ? decimalMatch[1].length : 0;

      var result;
      if (decimals > 0) {
        result = num.toFixed(decimals);
      } else {
        result = Math.floor(num).toString();
      }

      if (hasCommas) {
        var parts = result.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        result = parts.join('.');
      }

      return result;
    }

    function buildString(segments, progress) {
      var out = '';
      for (var i = 0; i < segments.length; i++) {
        var seg = segments[i];
        if (seg.type === 'text') {
          out += seg.value;
        } else {
          var current = seg.value * progress;
          out += formatNumber(current, seg.original);
        }
      }
      return out;
    }

    function animateCount(el) {
      var raw = el.getAttribute('data-count-up');
      var segments = parseSegments(raw);

      /* If there are no number segments, skip animation */
      var hasNumbers = segments.some(function(s) { return s.type === 'number'; });
      if (!hasNumbers) return;

      var start = performance.now();
      el.textContent = buildString(segments, 0);

      function tick(now) {
        var elapsed = now - start;
        var progress = Math.min(elapsed / duration, 1);
        var eased = easeOutCubic(progress);
        el.textContent = buildString(segments, eased);
        if (progress < 1) {
          requestAnimationFrame(tick);
        }
      }

      requestAnimationFrame(tick);
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !hasAnimated) {
          hasAnimated = true;
          countElements.forEach(function(el) {
            animateCount(el);
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    observer.observe(section);
  }

  /* Init all stats bar sections on the page */
  document.querySelectorAll('[data-section-type="stats-bar"]').forEach(initStatsBar);

  /* Support Shopify theme editor section re-renders */
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = e.target.querySelector('[data-section-type="stats-bar"]');
      if (section) initStatsBar(section);
    });
  }
})();